export const MAP_ROUTE = '/map';

export const MAP_PROFILE_ID_PARAM = 'profileId';

// The map centres on this profile when the query param is present.
export const getMapWithProfileRoute = (profileId: string): string =>
  `${MAP_ROUTE}?${MAP_PROFILE_ID_PARAM}=${encodeURIComponent(profileId)}`;
